import React, { Component } from 'react';

class Question extends Component {
    handleAnswerClick(weight, answer) {
        const { updateCategoryQuestion, categoryID, questionIndex } = this.props;
        
        updateCategoryQuestion(categoryID, questionIndex, answer, weight);
    }

    render() {
        const { question, index } = this.props;
        
        return (
            <div className="question">
                <p className="question-q" dangerouslySetInnerHTML={{__html: question.title}}/>
                {question.subtitle && (
                    <p className="question-subtitle">{question.subtitle}</p>
                )}
                <div className="question-answers">
                    {question.answers.map((ans, answerIndex) => {
                        return (
                            <div key={answerIndex} 
                                className={question.answer != null && (answerIndex === question.answer) ? "question-a __active" : "question-a"}
                                onClick={(e) => { this.handleAnswerClick(ans.weight, answerIndex) }}>
                                {ans.title}
                            </div>
                        );
                    })}
                        
                </div>
            </div>
        )
    }
}

export default Question;



// WEBPACK FOOTER //
// ./src/Question/Question.js